import { SelectableCriteriaWithParams } from '../base/search-criteria/selectable-criteria';

export const getCriteria = (list: SelectableCriteriaWithParams[], name: string) =>
  list.find((criterion) => criterion.name === name);
